import { useTranslation } from 'react-i18n-lite'
import { Button, Icon, LinkButton } from '@yes.technology/react-toolkit'

import { TaskActionsContainer, TaskActionsRow } from './TaskObjectCard.styles'
import { TaskActionsProps } from './TaskObjectCard.types'
import { useLocation } from 'react-router'

const TaskActions = ({
  statusUuid,
  taskUuid,
  statusActions,
  primaryStatusActionUuid,
  changeStatus,
  objectclassUuid,
  returnOnFinish = false
}: TaskActionsProps) => {
  const { t } = useTranslation()

  const isWaitingInteraction =
    window.waitingInteractionStatusUuid === statusUuid

  const validStatusActions = statusActions.filter(
    (statusAction) => statusAction.destination_status?.[0]
  )

  const sortedValidStatusActions = [
    ...validStatusActions.filter(
      (statusAction) => statusAction.uuid === primaryStatusActionUuid
    ),
    ...validStatusActions.filter(
      (statusAction) => statusAction.uuid !== primaryStatusActionUuid
    )
  ]

  const visualizeButton = (
    <LinkButton
      key='view'
      variant='secondary'
      heightClass='small'
      style={{ width: '24px', minWidth: '24px' }}
      aria-label={t('task.action.view')}
      href={`/${window.objectDetailsSitemodelUuid}?uuid_objectclass=${objectclassUuid}&object-uuid=${taskUuid}`}
    >
      <Icon iconName='Visualization' icSize='small' />
    </LinkButton>
  )

  const location = useLocation()
  const relativeEncodedUrl = encodeURIComponent(
    location.pathname + location.search + location.hash
  )

  return (
    <TaskActionsContainer>
      {isWaitingInteraction && (
        <TaskActionsRow>
          <LinkButton
            rel='noopener noreferrer'
            variant='primary'
            heightClass='small'
            href={`/${window.taskExecutorSitemodelUuid}?taskUuid=${taskUuid}&returnUrl=${relativeEncodedUrl}&returnOnFinish=${returnOnFinish.toString()}`}
          >
            {t('task.action.execute')}
          </LinkButton>
          {!validStatusActions.length && visualizeButton}
        </TaskActionsRow>
      )}
      {sortedValidStatusActions.map((statusAction, i) => (
        <TaskActionsRow key={`${statusAction.destination_status[0].code}_${i}`}>
          <Button
            variant={
              !isWaitingInteraction &&
              statusAction.uuid === primaryStatusActionUuid
                ? 'primary'
                : 'secondary'
            }
            heightClass='small'
            onClick={() =>
              changeStatus(statusAction.destination_status[0].code)
            }
          >
            {statusAction.des}
          </Button>
          {i === sortedValidStatusActions.length - 1 && visualizeButton}
        </TaskActionsRow>
      ))}
    </TaskActionsContainer>
  )
}

export default TaskActions
